export const resetTableData = () => dispatch => {
  dispatch({
    type: 'reset_table_data',
  });
  return Promise.resolve();
};
